const initialState = {
  data:{},
  search:'',
  filter:{type:''},
  sort:{
    field:'srvc_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_SRVCS':
      return {
        ...state,
        data: action.payload
      }
    case 'SORT_SRVCS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_SRVCS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_SRVCS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_SRVC':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.srvc_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/srvcs.js